import { useState } from "react";
import { toast } from "react-toastify";
import { showResponseError } from "Redux/Actions";

import "./Hero2.css";
import bazar from "Assets/Images/Hero2/bazar.png";
import anardooni from "Assets/Images/Hero2/anardooni.png";
import Google_Play from "Assets/Images/Hero2/Google_Play.png";
import myket from "Assets/Images/Hero2/myket.png";
import sibapp from "Assets/Images/Hero2/sibapp.png";
import webapp from "Assets/Images/Hero2/webapp.png";
import TextErr from "Assets/Locales/Persian/fa.json";
import { axios } from "Config/ApiConfig";
import API from "Constants/Apis";

const Hero2 = () => {
  const [state, setState] = useState({
    phoneNumber: "",
    number: "",
  });
  const onLink = (link) => {
    window.open(link, "_blank");
  };

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const fastRegister = (e) => {
    e.preventDefault();
    if (state.phoneNumber.length === 0) {
      toast(TextErr.nullPhoneNumber, { type: "warning" });
      return;
    } else if (state.phoneNumber.length < 11 && state.phoneNumber.length > 0) {
      toast(TextErr.underPhoneNumber, { type: "warning" });
      return;
    } else if (state.phoneNumber.length > 11) {
      toast(TextErr.upPhoneNumber, { type: "warning" });
      return;
    } else {
      window.open(
        `https://web-customer.daapapp.com/?${state.phoneNumber}`,
        "_blanck"
      );
      setState((prevState) => ({ ...prevState, phoneNumber: "" }));
    }
  };

  const PostMobile = (e) => {
    e.preventDefault();

    if (state.number.length === 0 || state.number === "") {
      toast(TextErr.nullPhoneNumber, { type: "warning" });
      return;
    } else if (state.number.length < 11 && state.number.length > 0) {
      toast(TextErr.underPhoneNumber, { type: "warning" });
      return;
    } else if (state.number.length > 11) {
      toast(TextErr.upPhoneNumber, { type: "warning" });
      return;
    } else {
      const data = {
        mobile: state.number,
      };

      axios({
        baseURL: API.SITE_API_V1,
        url: `main-page/download-link`,
        method: "POST",
        _addToken: false,
        data,
      })
        .then((response) => {
          if (response) {
            toast("لینک دانلود به شماره ارسال شد");
            setState((prevState) => ({ ...prevState, number: "" }));
          }
        })
        .catch((e) => {
          showResponseError(e);
        });
    }
  };

  return (
    <div className="container">
      <div className="row all-boxes-inputs">
        <div className=" each-box-input radius-boxes2 ">
          <h6 className="text-center title-box-input ">
            برای عضویت سریع در داپ‌اَپ، فرم زیر را تکمیل کنید
          </h6>
          <form onSubmit={fastRegister}>
            <input
              type="number"
              placeholder=" شماره موبایل (اجباری)"
              className="my-2 input-number "
              value={state.phoneNumber}
              name="phoneNumber"
              onChange={onChangeInput}
            />
          </form>

          <button
            className="button-inputs text-light px-3 btn-dap-slow-blue"
            onClick={fastRegister}
          >
            ثبت نام فوری
          </button>
        </div>
        <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3 each-box-input radius-boxes2 middle-input-box">
          <h6 className="text-center title-box-input">
            برای دانلود رایگان داپ‌اَپ، شماره‌ همراه خود را وارد کنید{" "}
          </h6>
          <form onSubmit={PostMobile}>
            <input
              type="number"
              placeholder="  09************"
              className="my-2 input-number "
              value={state.number}
              onChange={onChangeInput}
              name="number"
              maxLength={1}
            />
          </form>

          <button
            className="button-inputs text-light px-3 btn-dap-slow-blue"
            onClick={PostMobile}
          >
            ارسال لینک دانلود
          </button>
        </div>
        <div className="col-sm-12 col-md-3 col-lg-3 col-xl-3 each-box-input radius-boxes2 px-4">
          <h6 className="text-center title-box-input mb-4">
            اپلیکیشن داپ‌اَپ را از استورهای معتبر دانلود کنید
          </h6>
          <div className="row mb-2 ">
            <button
                onClick={() =>
                    onLink(
                        "https://play.google.com/store/apps/details?id=com.daapapp.crmrn"
                    )
                }
                className="col-4 px-1 border-0"
            >
              <img
                  src={Google_Play}
                  alt=""
                  loading="lazy"
                  className="link-image  "
              />
            </button>
            <button
                className=" col-4  px-1 border-0"
                onClick={() =>
                    onLink("https://cafebazaar.ir/app/com.daapapp.crmrn")
                }
            >
              <img src={bazar} alt="" loading="lazy" className="link-image "/>
            </button>
            <button
                onClick={() => onLink("https://myket.ir/app/com.daapapp.crmrn")}
                className="col-4 px-1 border-0"
            >
              <img src={myket} alt="" loading="lazy" className="link-image"/>
            </button>
          </div>
          <div className="row">
            <button
                className="col-6 px-1 border-0"
                onClick={() =>
                    onLink("https://anardoni.com/ios/app/nc2PaLAyW?lng=fa")
                }
            >
              <img
                  src={anardooni}
                  alt=""
                  loading="lazy"
                  className="link-image  "
              />
            </button>
            <button
                onClick={() => onLink("http://web-customer.daapapp.com/")}
                className="col-6 px-1 border-0"
            >
              <img src={webapp} alt="" loading="lazy" className="link-image "/>
            </button>
            {/*<button*/}
            {/*    onClick={() =>*/}
            {/*        onLink("https://sibapp.com/applications/APPLICATION_GACCBBEF")*/}
            {/*    }*/}
            {/*    className="col-4 px-1 border-0 "*/}
            {/*>*/}
            {/*  <img*/}
            {/*      src={sibapp}*/}
            {/*      alt=""*/}
            {/*      loading="lazy"*/}
            {/*      className="link-image    "*/}
            {/*  />*/}
            {/*</button>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero2;
